import { getSumInKopeiki } from "../../components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/SumInput/selectors";
import { getBindingFromId } from "../../components/PaymentContainer/components/PaymentSelection/components/PaymentMethodSection/Button/logic/utils";
export var getCommonParamsFromState = function getCommonParamsFromState(state, accountNumber, isAuthenticated) {
  var _state$selectedPaymen;
  return {
    from: accountNumber,
    isAuthenticated: isAuthenticated,
    sum: getSumInKopeiki(state),
    to: state.phoneInput.value,
    bindingId: getBindingFromId((_state$selectedPaymen = state.selectedPaymentId) !== null && _state$selectedPaymen !== void 0 ? _state$selectedPaymen : '')
  };
};